import { ChatMessageUser } from '@/components'
import type { MessageStatus } from '../api'

interface BotMessageUserProps {
  content: string
  status?: MessageStatus
}

export default function BotMessageUser({ content, status: _status }: BotMessageUserProps) {
  return (
    <ChatMessageUser
      message={{
        id: 0,
        type: 'user',
        content,
      }}
    />
  )
}
